// Return the default value for testCells
// @todo: remove constructorAB once confirmed by all teams ticket: https://beautypie.atlassian.net/browse/PI2-2129
export const parseExperimentFlags = (): Record<string, string | undefined> => {
  return {
    constructorAB: "constructor_1",
  }
}
